import React, { useEffect, useRef, useState } from "react";
import { AiOutlineMessage, AiOutlinePlus } from "react-icons/ai";
import { GrEmoji } from "react-icons/gr";
import { IoSend } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  add_friend,
  messageClear,
  send_message,
  updateMessage,
} from "../../store/reducers/chatReducer";
import toast from "react-hot-toast";
import io from "socket.io-client";
import { FaList } from "react-icons/fa";

const socket = io(`${process.env.REACT_APP_API || "http://localhost:4500"}`);

const Chat = () => {
  const scrollRef = useRef();
  const dispatch = useDispatch();
  const { sellerId } = useParams();
  const { userInfo } = useSelector((state) => state.auth);
  const { fb_messages, currentFd, my_friends, successMessage } = useSelector(
    (state) => state.chat
  );

  const [text, setText] = useState("");
  const [receverMessage, setReceverMessage] = useState("");
  const [activeSeller, setActiveSeller] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    socket.emit("add_user", userInfo.id, userInfo);
  }, [userInfo]);

  useEffect(() => {
    dispatch(
      add_friend({
        sellerId: sellerId || "",
        userId: userInfo.id,
      })
    );
  }, [sellerId, userInfo.id, dispatch]);

  const send = () => {
    if (text) {
      dispatch(
        send_message({
          userId: userInfo.id,
          text,
          sellerId,
          name: userInfo.name,
        })
      );
      setText("");
    }
  };

  useEffect(() => {
    socket.on("seller_message", (msg) => {
      setReceverMessage(msg);
    });

    socket.on("activeSeller", (sellers) => {
      setActiveSeller(sellers);
    });

    return () => {
      socket.off("seller_message");
      socket.off("activeSeller");
    };
  }, []);

  useEffect(() => {
    if (successMessage && fb_messages.length > 0) {
      socket.emit("send_customer_message", fb_messages[fb_messages.length - 1]);
      dispatch(messageClear());
    }
  }, [successMessage, dispatch, fb_messages]);

  useEffect(() => {
    if (receverMessage) {
      if (
        sellerId === receverMessage.senderId &&
        userInfo.id === receverMessage.receverId
      ) {
        dispatch(updateMessage(receverMessage));
      } else {
        toast.success(`${receverMessage.senderName} envió un mensaje`);
        dispatch(messageClear());
      }
    }
  }, [receverMessage, dispatch, sellerId, userInfo.id]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [fb_messages]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white p-3 rounded-md">
      <div className="relative flex w-full">
        {/* Friends/Sellers List */}
        <div
          className={`w-[230px] bg-white transition-all duration-300 absolute md:relative z-10 h-[500px] ${
            show ? "left-0" : "-left-[350px] md:left-0"
          }`}
        >
          <div className="flex justify-center gap-3 items-center text-slate-600 text-xl h-[50px] border-b">
            <AiOutlineMessage />
            <span>Mensajes</span>
          </div>
          <div className="w-full flex flex-col text-slate-600 py-4 h-[450px] overflow-y-auto">
            {my_friends.map((f, i) => (
              <Link
                to={`/dashboard/chat/${f.fdId}`}
                key={i}
                className="flex gap-2 items-center p-2 hover:bg-slate-100 rounded-md transition"
              >
                <div className="w-[30px] h-[30px] rounded-full relative">
                  {activeSeller.some((c) => c.sellerId === f.fdId) && (
                    <div className="w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0"></div>
                  )}
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={f.image}
                    alt=""
                  />
                </div>
                <span className="truncate">{f.name}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* Chat Window */}
        <div className="w-full ml-0 md:ml-3 border rounded-lg">
          {currentFd ? (
            <div className="flex flex-col h-[500px]">
              {/* Chat Header */}
              <div className="flex justify-between items-center h-[50px] px-4 border-b">
                <div className="flex items-center gap-2">
                  <div className="w-[30px] h-[30px] rounded-full relative">
                    {activeSeller.some(
                      (c) => c.sellerId === currentFd.fdId
                    ) && (
                      <div className="w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0"></div>
                    )}
                    <img
                      className="w-full h-full rounded-full object-cover"
                      src={currentFd.image}
                      alt=""
                    />
                  </div>
                  <span className="font-medium">{currentFd.name}</span>
                </div>
                <button
                  onClick={() => setShow(!show)}
                  className="md:hidden w-8 h-8 flex items-center justify-center bg-sky-500 text-white rounded"
                >
                  <FaList />
                </button>
              </div>

              {/* Messages */}
              <div
                ref={scrollRef}
                className="flex-1 bg-slate-50 p-4 overflow-y-auto"
              >
                <div className="flex flex-col gap-3">
                  {fb_messages.map((m, i) => (
                    <div
                      key={i}
                      className={`flex items-start gap-2 ${
                        currentFd?.fdId !== m.receverId
                          ? "justify-start"
                          : "justify-end"
                      }`}
                    >
                      <img
                        className="w-8 h-8 rounded-full"
                        src="/images/user.png"
                        alt=""
                      />
                      <div
                        className={`p-3 rounded-lg max-w-[80%] ${
                          currentFd?.fdId !== m.receverId
                            ? "bg-white text-gray-800"
                            : "bg-sky-500 text-white"
                        }`}
                      >
                        {m.message}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Input Area */}
              <div className="h-[60px] border-t flex items-center px-4 gap-2">
                <label className="w-10 h-10 flex items-center justify-center border rounded-full cursor-pointer">
                  <AiOutlinePlus className="text-xl" />
                  <input type="file" className="hidden" />
                </label>

                <div className="flex-1 relative">
                  <input
                    type="text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && send()}
                    placeholder="Escribe un mensaje..."
                    className="w-full h-10 px-4 pr-10 rounded-full border outline-none"
                  />
                  <button className="absolute right-3 top-1/2 -translate-y-1/2">
                    <GrEmoji className="text-xl" />
                  </button>
                </div>

                <button
                  onClick={send}
                  className="w-10 h-10 flex items-center justify-center bg-sky-500 text-white rounded-full"
                >
                  <IoSend />
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="flex justify-end items-center h-[50px] px-4">
                <button
                  onClick={() => setShow(!show)}
                  className="md:hidden w-8 h-8 flex items-center justify-center bg-sky-500 text-white rounded"
                >
                  <FaList />
                </button>
              </div>
              <div className="h-[500px] flex items-center justify-center text-slate-500">
                <span>Selecciona un vendedor para comenzar el chat</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Chat;
